const types = {
    SET_CONFIGS_LOADING: 'SET_CONFIGS_LOADING',
    SET_CONFIG: 'SET_CONFIG',
};

export default types;
